// extracted by mini-css-extract-plugin
export default {"plWrapper":"ClosingRound_plWrapper__Q3JyQ","closingRound":"ClosingRound_closingRound__jOJCp"};